import request from '@/utils/request'

const client_id = 'web'
const client_secret = '123456'
const scope = 'server'

// 登录方法
export function login () {
    return request({
        url: '/store-dev-auth/getLoginPath',
        method: 'get',
        // data: { username, password, code, uuid }
    })
}
// 登录方法
export function getAccessToken (data) {
    return request({
        url: '/store-dev-auth/login',
        method: 'post',
        data: data
    })
}
// 刷新方法
export function refreshToken () {
    return request({
        url: '/auth/refresh',
        method: 'post'
    })
}

// 获取用户详细信息
export function getInfo () {
    return request({
        url: '/store-dev-auth/dev_info',
        method: 'get',
    })
}

// 退出方法
export function logout () {
    return request({
        url: '/store-dev-auth/logout',
        method: 'delete'
    })
}

// 获取验证码
export function getCodeImg () {
    return request({
        url: '/code',
        method: 'get'
    })
}